export default "__VITE_ASSET__5IJdnJx8__ 584w";